import React, { useState } from 'react'
import moment from 'moment'
import injectStyles from 'react-jss'
import { Col, Grid, Row } from 'react-bootstrap'
import StatusLabel from '../StatusLabel'
import { styles } from './styles'
import GenericFlatButton from '../../../../../../../../Components/GenericFlatButton'
import { ADDENDUM_NAMES_MAP } from '../../const'
import { generateFullAddendumName } from '../../utils'
import { GERMANY_CONTRACT_STATUSES } from '../../../../../../../../shared/constants'

const AddendumList = ({
  classes,
  onContractNameClick,
  isOpen,
  addendums,
  onCancelAddendum,
  generateAddendumName,
  contract,
  ambassador,
}) => {
  const renderHeader = () => {
    return (
      <Row className={classes.row}>
        <Col xs={3}>
          <p className={classes.columnHeader}>Addendum</p>
        </Col>
        <Col xs={2}>
          <p className={classes.columnHeader}>Status</p>
        </Col>
        <Col xs={2}>
          <p className={classes.columnHeader}>Signed/Saved at</p>
        </Col>
        <Col xs={2}>
          <p className={classes.columnHeader}>Sent by</p>
        </Col>
      </Row>
    )
  }

  const FullTextOnHover = ({ add }) => {
    const [isHovered, setIsHovered] = useState(false)

    const handleMouseEnter = () => {
      setIsHovered(true)
    }

    const handleMouseLeave = () => {
      setIsHovered(false)
    }

    const fullName = generateFullAddendumName(
      add,
      ADDENDUM_NAMES_MAP[add.templateDocument.name],
      contract,
    )

    return (
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {isHovered ? (
          <div
            className={classes.link}
            onClick={() => onContractNameClick(add, `${fullName} addendum`)}
          >
            {fullName}
          </div>
        ) : (
          <div
            className={classes.link}
            onClick={() => onContractNameClick(add, `${fullName} addendum`)}
          >
            {generateAddendumName(add, contract)}
          </div>
        )}
      </div>
    )
  }

  const renderAddendum = addendum => {
    if (!addendum) return

    return (
      <Row className={classes.row}>
        <Col xs={3}>
          <FullTextOnHover add={addendum} />
        </Col>
        <Col xs={2}>
          <StatusLabel
            data={{
              ...addendum,
              status:
                contract.status ==
                  GERMANY_CONTRACT_STATUSES.STATUS_TERMINATED &&
                !addendum.signedAt
                  ? GERMANY_CONTRACT_STATUSES.STATUS_TERMINATED
                  : addendum.status,
            }}
            isAddendum={true}
          />
        </Col>
        <Col xs={2}>
          <p className={classes.columnValue}>
            {moment(
              addendum.signedAt
                ? Number(addendum.signedAt)
                : Number(addendum.createdAt),
            )
              .tz(ambassador.city.timezone)
              .format('DD.MM.YYYY HH:mm')}
          </p>
        </Col>
        <Col xs={2}>
          <p
            className={classes.userLink}
            onClick={() => {
              window.open(
                `/dashboard/users/${
                  addendum.metadata ? addendum.metadata.sender.id : null
                }`,
                '_blank',
              )
            }}
          >
            {addendum.metadata ? addendum.metadata.sender.name : '-'}
          </p>
        </Col>
        <Col xs={1}>
          {!addendum.signedAt &&
            contract.status !== GERMANY_CONTRACT_STATUSES.STATUS_TERMINATED && (
              <GenericFlatButton
                type={'filled'}
                title={'Cancel'}
                onClick={async () => await onCancelAddendum(addendum)}
                customStyles={classes.cancelButton}
              />
            )}
        </Col>
      </Row>
    )
  }

  return (
    <Grid fluid className={classes.container}>
      {renderHeader()}
      <div
        style={{
          height: isOpen ? 'auto' : 0,
          opacity: isOpen ? 1 : 0,
          overflow: 'hidden',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        {addendums.length > 0 && addendums.map(adds => renderAddendum(adds))}
      </div>
    </Grid>
  )
}

export default injectStyles(styles)(AddendumList)
